export interface LeaderboardData {
  users: LeaderboardUser[]
  seasonEndInSec: number
  leaderboardCapacity: number
  noOfUsersInLeaderboard: number
  userWantsToBeInLeaderboard: boolean
  currentLeague: number
  highestLeague: number
  promotionSettings: {
    promote: number
    demote: number
  }
}

export interface Ranks {
  avatar: string
  name: string
  rank: string
  type: string
  updated_at: string
  user_id: number
  xp: string | number
}
export interface MultiRanks {
  avatar: string
  name: string
  rank: string
  updated_at: string
  user_id: number
  value: string | number
}

export interface LeaderboardUser {
  id: number
  name: string
  avatar: string | null
  xp: number
  isCurrentUser?: boolean
}

export interface MultiLeaderboardData {
  userId: number
  nickname: string
  avatarPngUrl: string
  stats: {
    xp: number
    videoMinutes: number
    exercisesCompleted: number
    timeSpent: number
    certificatesEarned: number
  }
}

export enum LeagueNames {
  UNRANKED = 'unranked',
  BRONZE = 'bronze',
  SILVER = 'silver',
  GOLD = 'gold',
  PLATINUM = 'platinum',
  DIAMOND = 'diamond',
}

export enum LeagueType {
  UNRANKED = 0,
  BRONZE = 1,
  SILVER = 2,
  GOLD = 3,
  PLATINUM = 4,
  DIAMOND = 5,
}

export enum Linje5Tabs {
  OVERVIEW = 'overview',
  LEADERBOARD = 'leaderboard',
}

export enum LeaderboardFilterOptions {
  THIS_WEEK = 'thisWeek',
  LAST_WEEK = 'lastWeek',
  THIS_MONTH = 'thisMonth',
  LAST_MONTH = 'lastMonth',
  ALL_TIME = 'allTime',
}

export enum LeaderboardFilter {
  XP = 'xp',
  VIDEOS = 'videos',
  EXERCISES = 'exercises',
  TIME = 'time',
  CERTIFICATES = 'certificates',
}
